module.exports = ".glyphicon { color: white; font-size: 12px}\r\n.sub-menu{margin-left: 15px;font-size: 13px; display: block}\r\n/* .sub-menu.active{margin-left: 15px;\r\n  font-size: 13px; \r\n  display: block;\r\n  background-color: #7ec242 !important;\r\n  z-index: 0;\r\n} */\r\n.scroll-area{\r\n    width:100%;\r\n    float:left;\r\n    height: 100%;\r\n    overflow-y:auto;\r\n    padding-bottom: 100px;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/leftmenu/leftmenu.component.css
// module id = ./src/app/shared/leftmenu/leftmenu.component.css
// module chunks = main